import { render, staticRenderFns } from "./docPreview.vue?vue&type=template&id=6d0e84c1&"
import script from "./docPreview.vue?vue&type=script&lang=js&"
export * from "./docPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports